import { fetchUtils } from '$utils/fetchUtils'
import { filterState } from '$mapapp/MapApp/FilterControl/filter.svelte'
import type { LocationType } from '$mapapp/data/data.model'

class AvailableTypes {
	locationTypes: LocationType[] = $state([])
}

let isLoadingLocationTypes = $state(false)

export async function getLocationTypes() {
	if (isLoadingLocationTypes) {
		return
	}
	isLoadingLocationTypes = true

	await fetchUtils.get('/api/map/locationTypes', false).then((data: LocationType[]) => {
		for (const lt of data.sort((a, b) => a.priority - b.priority)) {
			if (!availableTypes?.locationTypes?.includes(lt)) {
				availableTypes.locationTypes.push(lt)
			}

			// Only initialize to false if preferences haven't already set a value for this type.
			// fetchFilterPreference() may have already run and set the user's saved value; we
			// must not overwrite it here (race condition: both calls are fired without awaiting).
			if (!(lt.code in filterState.popTypes)) {
				filterState.popTypes[lt.code] = false
			}
		}
		isLoadingLocationTypes = false
	})
}

export const availableTypes = new AvailableTypes()
